<template>
  <div>
 <mainTran
  :data_new="data"
  :boolUser_new="boolUser"
>
 </mainTran>
  </div>
</template>
<script>
import mainTran from "./main.vue";

export default {
    components: { mainTran },
  data() {
    return {
      data: [],
      boolUser: false,
    };
  },
  methods: {
  },
  mounted() {
    
  },
};
</script>
<style scoped>
</style>
